(function() {
    $(document).ready(function() {
        const oIpss = $.extend(true, {}, window.c24.lp.ipssReforged);
        oIpss.isWidgetPrefilledWithLastSearchData = true;
        oIpss.prefilledLabelsKeys = {
            'is': 'insuredRegion',
        };

        oIpss.filterChipLabelMap.offer = {
            'singular': 'Antrag',
            'plural': 'Anträge',
        };

        oIpss.bPriceInCents = true;

        oIpss.autoSelectContractTab = true;

        oIpss.tileHeadlineMap.incompleteContract = 'Antrag vervollständigen';
        oIpss.tileHeadlineMap.offer = 'Ihr letzter Antrag';
        oIpss.tileHeadlineMap.contract = 'Ihr letzter Vertrag';

        oIpss.bWholeTileClickable = false;

        oIpss.renderHeadline = function(data) {
            if (!oIpss.bUseTilesLayout) { // remove when all ipss are tiles layout
                const self = this;
                const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext);
                const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);
                const iAmountNonContracts = data.contracts ? data.contracts.length : 0;
                const iAmountLastSearches = data.lastSearches ? data.lastSearches.length : 0;
                const iAmountTotal = iAmountNonContracts + iAmountLastSearches;
                let amountHeadlineExtend = '';
                let bContractsOnly = false;
                let amountHeadline;
                let typeHeadline;
                let newHeadline;

                if (!self.isValidApiResponse(data)) {
                    newHeadline = {};

                    newHeadline.general = 'Meine letzte Aktivität';
                    newHeadline.lastSearches = 'Meine letzten Vergleiche';
                } else {

                    newHeadline = {};

                    if (data.contracts && iAmountNonContracts > 0) {

                        if (iAmountLastSearches > 0) {
                            typeHeadline = 'Aktivität';
                        } else {
                            bContractsOnly = true;

                            if (iAmountNonContracts > 1) {
                                typeHeadline = 'Anträge';
                            } else {
                                typeHeadline = 'Antrag';
                            }
                        }

                        if (iAmountTotal < 2) {
                            if (bContractsOnly) {
                                amountHeadline = 'Mein letzter ';
                            } else {
                                amountHeadline = 'Meine letzte ';
                                amountHeadlineExtend = '';
                            }
                        } else {
                            if (bContractsOnly) {
                                amountHeadline = 'Meine letzten ';
                                amountHeadlineExtend = '';
                            } else {
                                amountHeadline = 'Meine letzten ';
                                amountHeadlineExtend = 'en';
                            }
                        }

                        newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }

                    if (data.lastSearches) {

                        typeHeadline = 'Vergleich';

                        if (data.lastSearches.length < 2) {
                            amountHeadline = 'Mein letzter ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'e';
                        }

                        newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }
                }

                if (self.bShowContracts) {
                    if (iAmountNonContracts < 1 && data.lastSearches) {
                        newHeadline.general = newHeadline.lastSearches;
                        newHeadline.lastSearches = null;
                    }

                    $tabHeadlineLastSearches.text(newHeadline.general);

                    if (newHeadline.lastSearches === null) {
                        $headlineShowEverything.remove();
                    } else {
                        $headlineShowEverything.text(newHeadline.lastSearches);
                    }

                } else {
                    $('[id^="lastSearches"] .ipssHeadline:not(.showEverything)', self.domContext).text(newHeadline.general);
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }
            } else {
                const self = this;
                let amountHeadline;
                let typeHeadline;
                let amountHeadlineExtend = '';
                const newHeadline = {};
                const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext);
                const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);

                self.iAmountNonContracts = data.contracts ? data.contracts.length : 0;
                self.iAmountLastSearches = data.lastSearches ? data.lastSearches.length : 0;
                self.iAmountTotal = self.iAmountNonContracts + self.iAmountLastSearches;

                if (!self.isValidApiResponse(data)) {

                    newHeadline.general = 'Meine letzte Aktivität';
                    newHeadline.lastSearches = 'Meine letzten Vergleiche';
                } else {
                    if (data.contracts && self.iAmountNonContracts > 0) {

                        typeHeadline = 'Aktivität';

                        if (self.iAmountTotal < 2) {
                            amountHeadline = 'Meine letzte ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'en';
                        }

                        newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }

                    if (data.lastSearches) {

                        typeHeadline = 'Vergleich';

                        if (data.lastSearches.length < 2) {
                            amountHeadline = 'Mein letzter ';
                            amountHeadlineExtend = '';
                        } else {
                            amountHeadline = 'Meine letzten ';
                            amountHeadlineExtend = 'e';
                        }

                        newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                    }
                }

                if (self.bShowContracts) {

                    if (self.iAmountNonContracts < 1 && data.lastSearches) {
                        newHeadline.general = newHeadline.lastSearches;
                        newHeadline.lastSearches = null;
                    }

                    $tabHeadlineLastSearches.text(newHeadline.general);

                    if (newHeadline.lastSearches === null && self.aAppointmentsGrouped?.length < 0) {
                        $headlineShowEverything.remove();
                    } else {
                        $headlineShowEverything.text(newHeadline.lastSearches);
                    }

                } else {
                    $('[id^="lastSearches"] .ipssHeadline.nonContracts', self.domContext).text(newHeadline.general);
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }

                if (self.bUseTilesLayout && self.bIsMobile) {
                    $('.ipssHeadline.activities', self.domContext).text(`Meine Aktivitäten (${self.iAmountTotal})`);
                }
            }
        };

        oIpss.renderDataArrayProductSpecificTileHeadline = function(sRenderType, data) {
            if (sRenderType === 'offer' && data?.completed === false) {
                return 'Antrag vervollständigen';
            }

            return false;
        };

        oIpss.useLastSearchesLabelsAsFormData = function(lastSearchesLabels) {
            const self = this;
            const labels = Object.entries(lastSearchesLabels);
            labels.map(([key, value]) => {
                const valueToUse = value.value;
                const insuredRegionMap = {
                    'germany': '1',
                    'europe': '2',
                    'world': '3',
                };

                if (valueToUse) {
                    const formFields = self.$ac.find(`[name="${key}"]`);
                    for (const formField of formFields) {
                        if (formField.value === insuredRegionMap[valueToUse]) {
                            formField.checked = true;
                        }
                    }

                }
            });

        },

        oIpss.renderProductSpecificLabels = function (data) {
            const labels = { };
            const dataInputs = data.inputs;

            const familyStatusMap = {
                'single': 'Single',
                'pair': 'Paar',
                'family': 'Familie',
            };
            const insuredRegionMap = {
                'europe': 'Europa',
                'world': 'Welt',
                'germany': 'Deutschland',
            };

            if (!data.inputs) {
                return labels;
            }

            if (dataInputs.insuredRegion) {
                labels.insuredRegion = insuredRegionMap[dataInputs.insuredRegion] || null;
            } else {
                labels.insuredRegion = null;
            }

            if (dataInputs.familyStatus && familyStatusMap[dataInputs.familyStatus]) {
                let familyStatusPrefix = 'Geschütze Personen';
                if (dataInputs.familyStatus === 'single') {
                    familyStatusPrefix = 'Geschützte Person';
                }
                labels.familyStatus = `${familyStatusPrefix} | ${familyStatusMap[dataInputs.familyStatus]}`;
            } else {
                labels.familyStatus = null;
            }


            labels.age = null;
            if (dataInputs.age) {
                if (dataInputs.age >= 18 && dataInputs.age <= 30) {
                    labels.age = dataInputs.age.toString();
                } else if (dataInputs.age === 31) {
                    labels.age = 'älter als 30';
                }
            }

            if (dataInputs.zipCode) {
                labels.zipCode = dataInputs.zipCode;
            } else {
                labels.zipCode = null;
            }

            return labels;
        };

        oIpss.overrideData = {
            'version': 2,
            'lastUpdate': 1737972350117,
            'lastSearches': [
                {
                    'deviceOutput': 'desktop',
                    'time': 1737972334393,
                    'result': {
                        'cta': {
                            'text': 'Vergleich anzeigen',
                            'type': 'primary',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        'tariff': {
                            'best': {
                                'period': 'yearly',
                                'price': 2700,
                            },
                        },
                        'inputs': {
                            'age': 18,
                            'insuredRegion': 'germany',
                            'zipCode': '50636',
                            'familyStatus': 'single',
                            'fittingTariffs': 18,
                        },
                        'urlDelete': 'https://kfz-schutzbrief.check24-test.de/ap-ipss-api/SB/67975a6e56de59d60e826907',
                    },
                },
            ],
            'contracts': [
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1728570786166,
                    'type': 'offer',
                    'completed': true,
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'SB-579864990',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'firstyear',
                        'name': 'Komfort',
                        'price': 2950,
                    },
                    'insuranceKey': 'acv',
                    'inputs': {
                        'age': 31,
                        'insuredRegion': 'germany',
                        'zipCode': '80804',
                        'familyStatus': 'single',
                        'fittingTariffs': 1,
                    },
                },
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1728380699128,
                    'type': 'offer',
                    'completed': true,
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'SB-579861986',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'firstyear',
                        'name': 'Komfort',
                        'price': 2950,
                    },
                    'insuranceKey': 'acv',
                    'inputs': {
                        'age': 31,
                        'insuredRegion': 'germany',
                        'zipCode': '80804',
                        'familyStatus': 'single',
                        'fittingTariffs': 1,
                    },
                },
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1728380454576,
                    'type': 'offer',
                    'completed': true,
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'SB-579861895',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'firstyear',
                        'name': 'Help Plus',
                        'price': 4400,
                    },
                    'insuranceKey': 'avd',
                    'inputs': {
                        'age': 31,
                        'insuredRegion': 'world',
                        'zipCode': '80804',
                        'familyStatus': 'single',
                        'fittingTariffs': 1,
                    },
                },
                {
                    'status': {
                        'text': 'Antrag übermittelt',
                        'color': 'yellow',
                    },
                    'time': 1728380241067,
                    'type': 'offer',
                    'completed': true,
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': 'SB-579861828',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'firstyear',
                        'name': 'Komfort',
                        'price': 2950,
                    },
                    'insuranceKey': 'acv',
                    'inputs': {
                        'age': 31,
                        'insuredRegion': 'europe',
                        'zipCode': '80804',
                        'familyStatus': 'single',
                        'fittingTariffs': 1,
                    },
                },
                {
                    'status': {
                        'text': 'aktiv: ab 09.05.2025',
                        'color': 'green',
                    },
                    'time': 1730113183197,
                    'type': 'contract',
                    'deviceOutput': 'desktop',
                    'origin': 'external',
                    'publicId': '123456787654',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'zur Vertragsübersicht',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'period': 'firstyear',
                        'name': 'Komfort',
                        'price': 2950,
                    },
                    'insuranceKey': 'acv',
                    'inputs': {
                        'age': 31,
                        'insuredRegion': 'germany',
                        'zipCode': '80804',
                        'familyStatus': 'single',
                        'fittingTariffs': 1,
                    },
                },
            ],
            'staticTiles': [
                {
                    'cta': [
                        {
                            'text': 'jetzt Vertrag hinzufügen',
                            'type': 'primary',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                    ],
                    'time': 1737972350143,
                    'deviceOutput': 'desktop',
                    'subHeadline': 'Nicht bei uns abgeschlossen?',
                    'logo': 'https://kfz-schutzbrief.check24-test.de/content/foreign_contract_icon.svg',
                    'textLine1': 'Vertrag digitalisieren',
                    'textLine2': 'Keine Frist verpassen',
                    'textLine3': 'Günstigeres Angebot finden',
                },
            ],
        };

        oIpss.bind('kfzsb', 'https://kfz-schutzbrief' + window.c24LpDomain + '/ap-ipss-api/sb/v2', $('.mod24ac.kfzsb'));
    });
})();
